"use client";

import { type CarouselApi } from "@/components/ui/carousel";
import { cn } from "@/lib/ui/cn";

type CarouselIndicatorsProps = {
  api: CarouselApi | undefined;
  current: number;
  count: number;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  indicatorClassName?: string;
};

export function CarouselIndicators({
  api,
  current,
  count,
  className,
  activeClassName = "bg-emerald-light",
  inactiveClassName = "bg-white/60",
  indicatorClassName,
}: CarouselIndicatorsProps) {
  if (count <= 1) {
    return null;
  }

  return (
    <div className={cn("py-padding-element-lg flex w-full gap-1", className)}>
      {Array.from({ length: count }).map((_, index) => (
        <button
          key={index}
          className={cn(
            "h-1 w-full max-w-[53px] cursor-pointer rounded-sm transition-colors",
            current === index ? activeClassName : inactiveClassName,
            indicatorClassName,
          )}
          onClick={() => api?.scrollTo(index)}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  );
}
